module.exports = __webpack_public_path__ + "static/img/kid-6.6f1315e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kid-6.png
// module id = lN4n
// module chunks = 0